import SeoHead from "../components/SeoHead";
import { getSiteContent, localeRoutes } from "../i18n/siteContent";

function HomePage({ locale = "en" }) {
    const text = getSiteContent(locale).home;
    const site = getSiteContent(locale);
    const routes = localeRoutes[locale];
    const breadcrumbItems = [{ name: site.nav.home, path: routes.home }];

    return (
        <>
            <SeoHead
                title={text.title}
                description={text.description}
                keywords="Maurizio Brioschi, fractional cto, solution architect, cloud architect, digital transformation consultant, architecture modernization, AWS cloud strategy, agile engineering leader"
                path={routes.home}
                locale={locale}
                enPath={localeRoutes.en.home}
                itPath={localeRoutes.it.home}
                breadcrumbItems={breadcrumbItems}
                faqItems={text.faqItems}
            />
            <main className="mx-auto max-w-6xl px-4 py-10 sm:px-6">
                <header className="rounded-3xl bg-slate-900 p-8 text-white md:p-12">
                    <p className="text-xs font-semibold uppercase tracking-[0.3em] text-sky-200">{text.heroLabel}</p>
                    <h1 className="mt-4 text-4xl font-impact leading-tight md:text-5xl">{text.heroTitle}</h1>
                    <p className="mt-4 text-lg text-slate-100">{text.heroSubtitle}</p>
                    <p className="mt-4 max-w-3xl text-sm text-slate-200">{text.heroBody}</p>
                    <div className="mt-6 flex flex-wrap gap-3">
                        <a href={routes.contact} className="rounded-full bg-amber-500 px-5 py-3 text-sm font-semibold text-slate-900 transition hover:bg-amber-400">
                            {getSiteContent(locale).nav.cta}
                        </a>
                        <a href={routes.services} className="rounded-full border border-white/60 px-5 py-3 text-sm font-semibold text-white transition hover:bg-white/10">
                            {text.secondaryCta}
                        </a>
                    </div>
                    <p className="mt-6 text-xs text-slate-300">{text.proof}</p>
                </header>

                <section className="mt-10 grid gap-4 md:grid-cols-3">
                    {text.pillars.map((item) => (
                        <article key={item.title} className="rounded-2xl border border-slate-200 bg-white p-5">
                            <h2 className="text-lg font-semibold text-slate-900">{item.title}</h2>
                            <p className="mt-2 text-sm text-slate-600">{item.body}</p>
                        </article>
                    ))}
                </section>

                <section className="mt-10 rounded-2xl border border-slate-200 bg-white p-6">
                    <h2 className="text-2xl font-impact text-slate-900">{text.stuckSection.title}</h2>
                    <p className="mt-3 text-sm text-slate-600">{text.stuckSection.intro}</p>
                    <ul className="mt-4 space-y-2 text-sm text-slate-700">
                        {text.stuckSection.items.map((item) => (
                            <li key={item}>- {item}</li>
                        ))}
                    </ul>
                </section>

                <section className="mt-8 rounded-2xl border border-slate-200 bg-white p-6">
                    <h2 className="text-2xl font-impact text-slate-900">{text.fixSection.title}</h2>
                    <p className="mt-3 text-sm text-slate-600">{text.fixSection.intro}</p>
                    <ul className="mt-4 space-y-2 text-sm text-slate-700">
                        {text.fixSection.items.map((item) => (
                            <li key={item}>- {item}</li>
                        ))}
                    </ul>
                </section>

                <section className="mt-10 rounded-2xl border border-slate-200 bg-white p-6">
                    <h2 className="text-2xl font-impact text-slate-900">{text.engagementTitle}</h2>
                    <div className="mt-4 grid gap-4 md:grid-cols-3">
                        {text.engagement.map((item) => (
                            <div key={item.title}>
                                <h3 className="font-semibold text-slate-900">{item.title}</h3>
                                <p className="text-sm text-slate-600">{item.body}</p>
                            </div>
                        ))}
                    </div>
                    <div className="mt-6">
                        <a href={routes.contact} className="rounded-full bg-slate-900 px-5 py-3 text-sm font-semibold text-white transition hover:bg-slate-700">
                            {site.nav.cta}
                        </a>
                    </div>
                </section>

                <section className="mt-10 rounded-2xl border border-slate-200 bg-white p-6">
                    <h2 className="text-2xl font-impact text-slate-900">{text.faqTitle}</h2>
                    <p className="mt-3 text-sm text-slate-600">{text.faqIntro}</p>
                    <div className="mt-6 grid gap-4">
                        {text.faqItems.map((item) => (
                            <article key={item.question} className="rounded-xl border border-slate-200 bg-slate-50 p-5">
                                <h3 className="text-base font-semibold text-slate-900">{item.question}</h3>
                                <p className="mt-2 text-sm text-slate-700">{item.answer}</p>
                            </article>
                        ))}
                    </div>
                </section>

                <section className="mt-10 rounded-2xl border border-slate-200 bg-white p-6">
                    <h2 className="text-2xl font-impact text-slate-900">{text.internalLinksTitle}</h2>
                    <nav className="mt-4 grid gap-3 sm:grid-cols-2" aria-label={text.internalLinksTitle}>
                        {text.internalLinks.map((item) => (
                            <a
                                key={item.href}
                                href={item.href}
                                className="rounded-xl border border-slate-200 px-4 py-3 text-sm font-semibold text-slate-800 transition hover:border-amber-300 hover:text-amber-700"
                            >
                                {item.label}
                            </a>
                        ))}
                    </nav>
                </section>
            </main>
        </>
    );
}

export default HomePage;
